import CommonStore from "../../../stores/CommonStore";
import {action, makeObservable, observable} from "mobx";
import { ArticleDeliveryService } from "../../../service/productOrder/ArticleDeliveryService";
import ProductOrderStatsResponse from "../../../model/productOrder/ProductOrderStatsResponse";

class ArticleDeliveryStatsStore {

    public commonStore: CommonStore;
    public loading: boolean;
    public deliveryPersonId?: string;
    public articleDeliveryStats?: ProductOrderStatsResponse;

    constructor(
        commonStore: CommonStore,
        deliveryPersonId?: string
    ) {
        this.commonStore = commonStore;
        this.loading = true;
        this.deliveryPersonId = deliveryPersonId;
        makeObservable(this, {
            loading: observable,
            articleDeliveryStats: observable,
        });
    }

    @action
    public async getArticleDeliveryStats(): Promise<void> {
        this.loading = true;
        const response = await ArticleDeliveryService.getArticleDeliveryStats(this.deliveryPersonId);
        this.articleDeliveryStats = response;
        this.loading = false;
    }
}

export default ArticleDeliveryStatsStore;